<template>
    <div
        dir="ltr"
        class="c-owl-slide-show"
    >
        <carousel
            ref="owlCarousel"
            :items="items"
            :margin="margin"
            :loop="loop"
            :center="center"
            :nav="nav"
            :autoplay="autoplay"
            :autoplay-speed="autoplaySpeed"
            :rewind="rewind"
            :mouse-drag="mouseDrag"
            :touch-drag="touchDrag"
            :pull-drag="pullDrag"
            :free-drag="freeDrag"
            :stage-padding="stagePadding"
            :auto-width="autoWidth"
            :auto-height="autoHeight"
            :autoplay-timeout="autoplayTimeout"
            :dots="dots"
            :autoplay-hover-pause="autoplayHoverPause"
            :responsive="responsive"
            @change="eventHandler('change', $event)"
            @update="eventHandler('update', $event)"
            @changed="changed($event)"
        >
            <slot />
        </carousel>
    </div>
</template>

<script>
    import carousel from 'vue-owl-carousel2';
    import props from './props';

    export default {
        name      : 'OwlSlideShow',
        components: { carousel },
        mixins    : [props],

        props: {
            itemIndex: Number,
        },

        watch: {
            /**
             * watch changes of item index value
             * 
             * @param {*} val 
             */
            itemIndex(val) {
                this.specificSlide(val);
            },
        },

        /**
         *
         */
        mounted() {
            this.$refs.owlCarousel.owl.on('changed.owl.carousel', (event) => {
                if (event.item.index - 1) {
                    return this.$emit('indexItem', event.item.index - 1);
                }
                return event.item.count;
            });
        },

        methods: {
            /**
             * Slide show Event Handler
             *
             * @param {string} key
             * @param {*} value
             */
            eventHandler(key, value) {
                this.$emit(key, value);
            },

            /**
             * Go next item carousel
             *
             */
            nextItem() {
                this.$refs.owlCarousel.owl.trigger('next.owl.carousel');
            },

            /**
             * Go prev item carousel
             *
             */
            prevItem() {
                this.$refs.owlCarousel.owl.trigger('prev.owl.carousel');
            },

            /**
             * Go to specific slide
             *
             * @param {*} index
             */
            specificSlide(index) {
                this.$refs.owlCarousel.owl.trigger('to.owl.carousel', index - 1);
            },

            /**
             * changed
             *
             * @param {string} index
             */
            changed(index) {
                this.$emit('changed-index', index.page.index );
            },
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
